import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import styled from 'styled-components';
const Container = styled.button `
  ${ButtonReset};

  &[disabled] {
    opacity: 0.25;
  }

  /* Padding */
  &[data-size='small'] {
    --buttonPaddingY: 8px;
    --buttonPaddingX: 12px;
  }

  &[data-size='medium'] {
    --buttonPaddingY: 14px;
    --buttonPaddingX: 12px;
  }

  &[data-size='large'] {
    --buttonPaddingY: 20px;
    --buttonPaddingX: 24px;
  }

  &[data-icon] {
    --buttonPaddingY: 11px;
  }

  /* Theme */
  &[data-theme='white'] {
    --buttonBg: ${brand.primary.white};
    --buttonFg: ${brand.primary.darkBlue};
    --buttonBgHover: ${brand.primary.darkBlue};
    --buttonFgHover: ${brand.primary.white};

    &[data-inverted='true'] {
      --buttonBg: ${brand.primary.darkBlue};
      --buttonFg: ${brand.primary.white};
      --buttonBgHover: ${brand.primary.white};
      --buttonFgHover: ${brand.primary.darkBlue};
    }
  }

  &[data-theme='light-blue'] {
    --buttonBg: ${brand.primary.brightBlue};
    --buttonFg: ${brand.primary.white};
    --buttonBgHover: ${brand.primary.white};
    --buttonFgHover: ${brand.primary.brightBlue};
    --buttonBorderColour: ${brand.primary.white};
    --buttonBorderColourHover: ${brand.primary.brightBlue};

    &[data-inverted='true'] {
      --buttonBg: ${brand.primary.white};
      --buttonFg: ${brand.primary.brightBlue};
      --buttonBgHover: ${brand.primary.brightBlue};
      --buttonFgHover: ${brand.primary.white};
      --buttonBorderColour: ${brand.primary.brightBlue};
      --buttonBorderColourHover: ${brand.primary.white};
    }
  }

  &[data-theme='dark-blue'] {
    --buttonBg: ${brand.primary.darkBlue};
    --buttonFg: ${brand.primary.white};
    --buttonBgHover: ${brand.primary.white};
    --buttonFgHover: ${brand.primary.darkBlue};

    &[data-inverted='true'] {
      --buttonBg: ${brand.primary.white};
      --buttonFg: ${brand.primary.darkBlue};
      --buttonBgHover: ${brand.primary.darkBlue};
      --buttonFgHover: ${brand.primary.white};
    }
  }

  /* Variant */
  --buttonGap: 5px;

  &[data-variant='inline'] {
    --buttonRadius: 0px;
    --buttonFg: var(--sectionForegroundColor, ${brand.primary.darkBlue});
    --buttonFgHover: var(--buttonFg);
    --buttonBg: transparent;
    --buttonBgHover: transparent;
    --buttonPaddingY: 0px;
    --buttonPaddingX: 0px;

    [data-theme='white'] & {
      --buttonFg: ${brand.primary.white};
    }
  }

  &[data-variant='box'] {
    --buttonRadius: 3px;
    --buttonBorderSize: 1px;
    --buttonBorderColour: ${brand.grey.base};
    --buttonBorderColourHover: ${brand.grey.base};
    --buttonFg: ${brand.grey.base};
    --buttonFgHover: ${brand.grey.base};
    --buttonBg: transparent;
    --buttonBgHover: transparent;
    --buttonPaddingY: 21px;
    --buttonPaddingX: 23px;
    --buttonGap: 10px;
  }

  &[data-variant='button'] {
    --buttonRadius: 8px;
  }

  &[data-variant='bordered-button'] {
    --buttonRadius: 8px;
    --buttonBorderSize: 2px;
  }

  &[data-theme-hover='white'] {
    --buttonBgHover: ${brand.primary.white};
    --buttonFgHover: ${brand.primary.darkBlue};
  }

  &[data-theme-hover='light-blue'] {
    --buttonBgHover: ${brand.primary.brightBlue};
    --buttonFgHover: ${brand.primary.white};
  }

  &[data-theme-hover='dark-blue'] {
    --buttonBgHover: ${brand.primary.darkBlue};
    --buttonFgHover: ${brand.primary.white};
  }

  &[data-theme-hover='pale-blue'] {
    --buttonBgHover: #d9ebff;
    --buttonFgHover: ${brand.primary.darkBlue};
  }

  display: flex;
  gap: var(--buttonGap);
  justify-content: center;
  align-items: center;
  text-decoration: none;

  padding: var(--buttonPaddingY) var(--buttonPaddingX);
  border: var(--buttonBorderSize, 0) solid var(--buttonBorderColour, transparent);
  border-radius: var(--buttonRadius);
  background-color: var(--buttonBg);
  color: var(--buttonFg);

  &:hover {
    background-color: var(--buttonBgHover);
    color: var(--buttonFgHover);
    border-color: var(--buttonBorderColourHover);
  }

  ${transition('background-color, color, border-color, opacity', '200ms', 'cubic-bezier(.165,.84,.44,1)')};

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
  }
`;
const Text = styled.span `
  ${fonts.ubuntu.regular};

  [data-variant='inline'] & {
    text-decoration: underline;
  }

  [data-variant='box'] & {
    text-transform: uppercase;
  }
`;
const IconWrapper = styled.div `
  flex-shrink: 0;
  width: 22px;
  height: 22px;

  svg {
    width: 100%;
    height: 100%;
  }
`;
const ButtonStyles = {
    Container,
    IconWrapper,
    Text,
};
export default ButtonStyles;
